const TTL = 60000 // 1분

export function setCache(key, data) {
  localStorage.setItem(
    key,
    JSON.stringify({
      data,
      timestamp: Date.now(),
    }),
  )
}

export function getCache(key) {
  const raw = localStorage.getItem(key)
  if (!raw) return null

  const cached = JSON.parse(raw)
  // 1분 지났을때
  if (Date.now() - cached.timestamp > TTL) {
    localStorage.removeItem(key)
    return null
  }
  return cached.data
}
